import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreConfigTemplate = {
    velocityKmhMin: 0,
    velocityKmhMax: 0,
    scoreOnMatch: 0,
  };
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addScore = () => {
    updateData((draft) => {
      draft.scores.push(structuredClone(scoreConfigTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((draft) => {
      draft.scores.splice(index, 1);
    });
  };

  return (
    <>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Neat velocity - Ride duration [hour]</td>
            <td>
              <input
                type="number"
                value={data.longRideDurationHours}
                onChange={(e) =>
                  updateData((d) => {
                    d.longRideDurationHours = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Neat velocity - Rest duration [hour]</td>
            <td>
              <input
                type="number"
                value={data.longRestDurationHours}
                onChange={(e) =>
                  updateData((d) => {
                    d.longRestDurationHours = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Gross velocity - threshold [km/h]</td>
            <td>
              <input
                type="number"
                value={data.maxGrossVelocityKmhThreshold}
                onChange={(e) =>
                  updateData((d) => {
                    d.maxGrossVelocityKmhThreshold = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Gross velocity - threshold score</td>
            <td>
              <input
                type="number"
                value={data.maxGrossVelocityKmhThresholdScore}
                onChange={(e) =>
                  updateData((d) => {
                    d.maxGrossVelocityKmhThresholdScore = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup min [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMin}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMin =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup max [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDaysMax}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDaysMax =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Ignored country codes</td>
            <td>
              <input
                type="text"
                value={UtilService.arrayToCsv(data.ignoredCountryCodes)}
                onChange={(e) =>
                  updateData((d) => {
                    d.ignoredCountryCodes = UtilService.csvToStringArray(
                      e.target.value,
                    );
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table className="config-table-double table-with-button">
        <thead>
          <tr>
            <th>
              Neat velo. Min <small>[km/h]</small>
            </th>
            <th>
              Neat velo. Max <small>[km/h]</small>
            </th>
            <th>Score</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={() => addScore()}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.scores.map((score, index) => (
            <tr key={index}>
              <td>
                <input
                  type="number"
                  value={score.velocityKmhMin}
                  min={0}
                  max={score.velocityKmhMax}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].velocityKmhMin = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  value={score.velocityKmhMax}
                  min={score.velocityKmhMin}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].velocityKmhMax = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  min={0}
                  value={score.scoreOnMatch}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index].scoreOnMatch = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Component;
